import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

import navigation from './modules/navigation';
import variables from './modules/variables';
import app from './modules/app';

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [createPersistedState({
    key: 'air-app-params',
    filter(mutation) {
      return mutation.type.indexOf('app/') === 0;
    },
  })],
  modules: {
    navigation,
    variables,
    app
  },
});



// WEBPACK FOOTER //
// ./src/store/index.js